import './style.css'
import ExclusiveItem from "../../../../entity/main-page/components/exclusive-item";
import Slider from "react-slick";
import {useEffect, useRef, useState} from "react";

const Exclusive = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1180);
    // const sliderRef = useRef<Slider | null>(null);
    const exclusiveSectionRef = useRef<HTMLDivElement>(null)
    const [isOpenAllList, setIsOpenAllList] = useState(true);

    const changeVisibilList = () => {
        setIsOpenAllList(!isOpenAllList);
    }
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1180);
        };
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // const nextArrowHandler = () => {
    //     if (sliderRef.current) {
    //         sliderRef.current.slickNext();
    //     }
    // };

    // const prevArrowHandler = () => {
    //     if (sliderRef.current) {
    //         sliderRef.current.slickPrev();
    //     }
    // };
    // const settings = {
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     prevArrow: <button className="exclusive__slider__button exclusive__slider-left">&#8592;</button>,
    //     nextArrow: <button className="exclusive__slider__button exclusive__slider-right">&#8594;</button>,
    //     dots: false,
    //     infinite: false,
    // };

    if (exclusiveSectionRef.current && isOpenAllList) {
        exclusiveSectionRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    }
    return (
        <section className="exclusive" id="exclusive" ref={exclusiveSectionRef}>
            <div className="container">
                <div className="exclusive-body">
                    <h2 className="exclusive-title title">
                        Эксклюзивные <span>предложения</span>
                    </h2>
                    <div className="exclusive-list">
                        <ExclusiveItem isOpenAllList={isOpenAllList} />
                        {/* {isMobile ? (
                            <Slider ref={sliderRef} {...settings}>
                                    <ExclusiveItem isOpenAllList={isOpenAllList} />
                            </Slider>
                        ) : (
                            <>
                                    <ExclusiveItem isOpenAllList={isOpenAllList} />
                            </>
                        )} */}
                    </div>

{/* 
                    <button className="exclusive__button button"
                            onClick={changeVisibilList}
                    >
                        {!isOpenAllList
                        ? "Скрыть"
                        : "Посмотреть все предложения"}
                    </button> */}


                    {/* <div className="exclusive__slider__buttons">
                        <button
                            className="exclusive__slider__button exclusive__slider-left"
                            onClick={prevArrowHandler}
                        >
                            &#8592;
                        </button>
                        <button
                            className="exclusive__slider__button exclusive__slider-right"
                            onClick={nextArrowHandler}
                        >
                            &#8594;
                        </button>
                    </div> */}
                </div>
            </div>
        </section>
    );
};

export default Exclusive;